import React from "react";
import { Button } from "@/components/ui/button";
import HeroStats from "./HeroStats";
import HeroBadge from "./HeroBadge";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

interface HeroContentProps {
  scrollToProcess: () => void;
}

const HeroContent = ({ scrollToProcess }: HeroContentProps) => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const heroData = labels.menuPages?.sellCar?.hero || {};

  return (
    <div className="text-center max-w-4xl mx-auto">
      <HeroBadge />

      <div className="relative">
        <h1 className="text-5xl sm:text-6xl md:text-6xl lg:text-7xl font-bold mb-6 md:mb-8 leading-tight text-white">
          <span className="block">{heroData.title || "Sälja Din Bil"}</span>
          <span className="block bg-gradient-to-r from-emerald-400 via-cyan-400 to-purple-400 bg-clip-text text-transparent">
            {heroData.subtitle || "Enkelt Online"}
          </span>
        </h1>

        <p className="text-xl md:text-xl lg:text-2xl mb-4 md:mb-6 text-gray-300 max-w-3xl mx-auto px-2">
          {heroData.description ||
            "Via BILENIA & BEA Auktioner - Sverige, Norden & Europa"}
        </p>

        <p className="text-base md:text-lg mb-8 md:mb-12 text-gray-400 leading-relaxed max-w-2xl mx-auto px-2">
          {heroData.subDescription ||
            "Kostnadsfri värdering av din bil - svar online. Test-klar på 10 min."}
        </p>

        <div className="flex justify-center px-4 mb-12 md:mb-16">
          <Button
            onClick={scrollToProcess}
            size="lg"
            className="bg-gradient-to-r from-emerald-600 to-cyan-600 hover:from-emerald-700 hover:to-cyan-700 text-white px-8 md:px-10 py-4 md:py-5 text-base md:text-lg font-semibold rounded-2xl shadow-2xl hover:shadow-emerald-500/25 transition-all duration-300 border border-emerald-400/20"
          >
            {heroData.cta || "Starta Försäljning"}
          </Button>
        </div>

        <HeroStats />
      </div>
    </div>
  );
};

export default HeroContent;
